/* eslint-disable */
/**
 * This file was generated by Itecho.TSGen tool
 * Version and info generated in .version
 * Any changes to this file will be lost if regenerated 
 */

import { webRequest, fileRequest } from "../request";
import type FirmwareUpdateRequest from "../interfaces/firmwareUpdateRequest";
import type FirmwareUploadRequest from "../interfaces/firmwareUploadRequest";
import type FirmwareVersion from "../interfaces/firmwareVersion";
import type PaginationRequestSearch from "../interfaces/paginationRequestSearch";
import type PaginationResponse from "../interfaces/paginationResponse";

export default {
    paged: (request: PaginationRequestSearch) => webRequest<PaginationResponse<FirmwareVersion>>('/api/firmware/paged', {
        method: 'post',
        body: request
    }),
    insert: (request: FirmwareUploadRequest) => webRequest<void>('/api/firmware/insert', {
        method: 'post',
        body: request,
        binding: 'form'
    }),
    update: (request: FirmwareUpdateRequest) => webRequest<void>('/api/firmware/update', {
        method: 'post',
        body: request,
        binding: 'form'
    }),
    all: () => webRequest<FirmwareVersion[]>('/api/firmware/all'),
    allVersions: () => webRequest<string[]>('/api/firmware/allversions'),
    getFirmwareVersions: () => webRequest<unknown>('/api/firmware/getfirmwareversions')
}